<template>
    <div class="risePercentList">
        <div class="memo">*4/5表示新股上涨数/该行业新股总数</div>
        <div class="item" :key="item.id" v-for="item in listData">
            <div class="upRow">
                <span class="rank">TOP {{item.rank}}</span>
                <span class="arrow"><img src="../assets/arrow.png"></span>
                <span class="industry">{{item.name}}</span>
            </div>
            <div class="downRow">
                <span class="bar"><span class="innerBar" :style='"width:"+item.amount/item.total*100+"%;"'></span></span>
                <span class="value">{{item.amount}}/{{item.total}}</span>
            </div>
        </div>
        <div @click="toMore()" yybp="{tracking_type:click, event_id:yfyy_ipo_list_home_more_related_industry}"><buttonToMore></buttonToMore></div>
    </div>
</template>

<script>
export default {
    name: 'risePercentList',
    components: {
        buttonToMore: (resolve) => {require(["../components/buttonToMore"],resolve)}
    },
    data(){
        return {
            listData: [
                {rank: 1, name:'工业',amount: 4, total: 10},
                {rank: 1, name:'工业',amount: 4, total: 10},
                {rank: 1, name:'工业',amount: 4, total: 10},
                {rank: 1, name:'工业',amount: 4, total: 10}
            ]
        }
    },
    methods: {
        getQuery: function (name) {
            let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
            let r = window.location.search.substr(1).match(reg);
            if (r != null) {
                return decodeURIComponent(r[2]);
            };
            return null;
        },
        toMore(){
            window.location.href = window.location.href.split("#")[0] + "&dimension=industry#related-list";
        }
    },
    created(){
        let url = location.protocol+"//"+location.hostname+"/api/youyu-ipo-list/related-list";
        this.$http.get(url,{params:{
            startDate:this.getQuery("startDate"),
            endDate:this.getQuery("endDate"), 
            dimension:"industry"
        }}).then((response) => {
            // console.log(response.data);
            this.listData = response.data.data.data.slice(0,5);
            for (let i = 0; i < this.listData.length; i++){
                this.listData[i].rank = i + 1;
            }
        })
    }
}
</script>

<style lang="scss" scoped>
.risePercentList {
    position: relative;
    padding: .1rem .26rem 0rem;
    margin: auto;
    font-family: 'Noto Sans SC', sans-serif;
    font-weight: 500;
    text-align: left;
}

.memo {
    text-align: center;
    font-size: 0.22rem;
    opacity: 0.5;
    margin-bottom: 0.2rem; 
}

.item {
    margin: .3rem 0rem;
}

.rank {
    margin: .13rem;
    font-size: .24rem;
    line-height: .24rem;
    color: #F49B3B;
}

.arrow img{
    height: .12rem;
    padding: .02rem;
}

.industry {
    margin: .13rem .04rem;
    font-size: .24rem;
    line-height: .24rem;
    color: #3E4171;
}

.bar {
    display: inline-block;
    width: 90%;
    height: .15rem;
    border-radius: 7.5rem;
    background: #E0E8FE;
}

.innerBar {
    display: block;
    height: 100%;
    border-radius: 7.5rem;
    background: #5670FF;
}

.value {
    display: inline-block;
    width: 10%;
    text-align:right;
}
</style>